import { stringSearch, useSetSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { PartDetailsTabContent } from '@/areas/parts/PartDetailsPage/components/PartDetailsTabController';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/parts/details/$partId/')({
    staticData: { access: { permissions: ['view:part_library'] }, chrome: 'home' } satisfies PageStaticData,
    validateSearch: stringSearch({ taskId: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const { partId } = Route.useParams();
    const requiredQuantity = Route.useSearch({ select: (search) => search.requiredQuantity });
    const setSearch = useSetSearch();
    return (
        <PartDetailsTabContent
            tab={undefined}
            partId={partId}
            pricingSearch={{ requiredQuantity, onSearchChange: setSearch }}
        />
    );
}
